import React, { useState, useEffect, useCallback } from 'react'

import { useHistory } from "react-router-dom"

import TextField from '@material-ui/core/TextField'
import Pagination from '@material-ui/lab/Pagination'
import CircularProgress from '@material-ui/core/CircularProgress'

import { AuthUserContext, withAuthorization } from '../../contexts/Session'
import Header from '../../components/Header/Admin/index'
import DenuncesTypeButton from '../../components/Button/index'
import searchButton from '../../assets/Icons/searchButton.svg'
import ModalDenunciations from '../../components/Modal/Admin/Denunciations/index'
import api from '../../services/api'
import CardDenunciations from '../../components/Cards/Denunciations/index'

import {ToggleButton} from '../../components/ToggleButtom';

import './styles.css';

const ListDenunciations = (props) => {

    const history = useHistory()

    const[showModalDenunciations, setShowModalDenunciations] = useState(false);
    
    const[denunces, setDenunces] = useState([]);

    const[pages, setPages] = useState(null);
    const[currentPage, setCurrentPage] = useState(1);
    const[mount, setMount] = useState(false);

    const [search, setSearch] = useState('');

    const[viewTodos, setviewTodos] = useState(true);
    const[viewLeve, setviewLeve] = useState(false);
    const[viewModerado, setviewModerado] = useState(false);
    const[viewGrave, setviewGrave] = useState(false);
    const[viewMuitoGrave, setviewMuitoGrave] = useState(false);
    const[viewMaximo, setviewMaximo] = useState(false);

    const[filter, setFilter] = useState(false);

    const[disaleButton, setDisableButton] = useState(false);
    const[disablePagination, setDisablePagination] = useState(false);

    const[error, setError] = useState(false);
    const[load, setLoad] = useState(true);

    const joinFields = useCallback(async (data) => {
        const denunciations = [];
        for (let i = 0; i < data.denunciations.length; i++) {
            const element = {...data.denunciations[i], users: data.users[i]};
            denunciations.push(element);
        }
        setDenunces(denunciations);
    }, []);

    const handleShowAllDenunciations = useCallback(async () => {
        let option;
        if (filter) {
            option = 1;      
        }else{
            option = 0;      
        }
        console.log(currentPage);
        await api.get(`/denunciations/get`, 
            {   
                params: { 
                    pageNumber: currentPage,
                    pageLimit: 15,
                    filter: option,
                },
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,   
                }
            }
        ).then((response) =>{
            console.log(response, 'denuncesPage');
            setPages(response.data.pages);
            joinFields(response.data);
            setMount(true);
            setLoad(false);
            setTimeout(()=>setDisableButton(false), 3000);
            setTimeout(()=>setDisablePagination(false), 2000);
        }).catch(() =>{
            setError(true);
            setDisableButton(false);
            setDisablePagination(false);
            props.firebase.auth.currentUser.getIdTokenResult()
                .then((idTokenResult) => {
                    localStorage.setItem('@Z52InSD4dnfjUDeVSEB0Byy',idTokenResult.token);
                    localStorage.setItem('VSEB0Byy',idTokenResult.claims.user_id);
                })
                .catch((error) => {
                    console.log(error);
                })
        })
    }, [currentPage, filter, joinFields, props.firebase.auth.currentUser]);

    const handleShowByRisk = useCallback(async (max, min) => {
        let option;
        if (filter) {
            option = 1;      
        }else{
            option = 0;      
        }
        await api.get(`/denunciations/getByRiskInterval`, 
            {
                params: {
                    max: max, 
                    min: min,
                    pageNumber:currentPage,
                    pageLimit: 15,
                    filter: option,
                },
                headers: {
                    authorization: `Bearer ${localStorage.getItem('@Z52InSD4dnfjUDeVSEB0Byy')}`,   
                }
            },
        ).then((response) =>{
            //console.log(response, 'denuncesPage');
            setPages(response.data.pages);
            joinFields(response.data);
            setMount(true);
            setLoad(false);
            setTimeout(()=>setDisableButton(false), 3000);
            setTimeout(()=>setDisablePagination(false), 2000);
        }).catch(() =>{
            setError(true);
            setDisableButton(false);
            setDisablePagination(false);
            props.firebase.auth.currentUser.getIdTokenResult()
                .then((idTokenResult) => {
                    localStorage.setItem('@Z52InSD4dnfjUDeVSEB0Byy',idTokenResult.token);
                    localStorage.setItem('VSEB0Byy',idTokenResult.claims.user_id);
                })
                .catch((error) => {
                    console.log(error);
                })
        })
    }, [currentPage, filter, joinFields, props.firebase.auth.currentUser]);

    const handleChangeStatus = useCallback(async () => {
        setMount(false);
        console.log('opa', 'opalisdenunciation');
    }, []);

    const searchDiagnosis = useCallback(async (event) => {      
        if (event !== undefined) {
            event.preventDefault();
        }
        setDisableButton(true);
        setDisablePagination(true);
        setLoad(true);   
        if (search.length !== 0) {
            let option;
            if (filter) {
                option = 1;      
            }else{
                option = 0;      
            }
            await api.get('/denunciations/search', 
                {  
                    params: {
                        pageNumber: currentPage,
                        pageLimit: 15,
                        keyword: search, 
                        filter: option,
                    }
                },
            ).then( (response) =>{
                console.log(response.data);
                setPages(response.data.pages);
                joinFields(response.data);
                setMount(true);
                setLoad(false);
                setTimeout(()=>setDisableButton(false), 3000);
                setTimeout(()=>setDisablePagination(false), 2000);
            }).catch((e) =>{
                console.log(e, 'CatchSearchViewTodos');
            });  
            setLoad(false);  
        }else{
            setMount(false);
        }
    }, [currentPage, filter, joinFields, search]);

    useEffect(() => {
        if(!mount){
            if (search.length === 0) {
                if(viewTodos){
                    handleShowAllDenunciations();
                }
                
                if (viewLeve){
                    handleShowByRisk(0.024, 0);
                }
                
                if (viewModerado){
                    handleShowByRisk(0.274, 0.024);
                } 
                
                if (viewGrave){
                    handleShowByRisk(0.5424, 0.274);
                }
                
                if (viewMuitoGrave){
                    handleShowByRisk(0.774, 0.5424);
                }
                
                if (viewMaximo){
                    handleShowByRisk(null, 0.774);
                }
            }else{
                searchDiagnosis();
            }
        }
    }, [denunces, handleShowAllDenunciations, handleShowByRisk, mount, search.length, searchDiagnosis, viewGrave, viewLeve, viewMaximo, viewModerado, viewMuitoGrave, viewTodos]);

    return(
        <AuthUserContext.Consumer> 
        {authUser =>
            authUser ? 
                <div>
                    <Header/>
                    <div className='container-management'>
                        <h1 className='page-title-adm'> Gestão de denuncias</h1>
                        <h2 className='page-title-adm'> Grau de risco</h2>
                        <div className='page-profiles-button'>
                            <DenuncesTypeButton 
                                name='Maximo'
                                type='Denunce' 
                                white={viewMaximo} 
                                
                                setviewMaximo={setviewMaximo}
                                setviewMuitoGrave={setviewMuitoGrave} 
                                setviewGrave={setviewGrave}
                                setviewModerado={setviewModerado}
                                setviewLeve={setviewLeve} 
                                setviewTodos={setviewTodos}
                                
                                setMount={setMount} 
                                disable={disaleButton}
                                setDisabled={setDisableButton}
                                setCurrentPage={setCurrentPage}
                                setLoad={setLoad}
                            />

                            <DenuncesTypeButton 
                                name='Muito Grave'
                                type='Denunce'  
                                white={viewMuitoGrave} 
                                
                                setviewMaximo={setviewMaximo}
                                setviewMuitoGrave={setviewMuitoGrave} 
                                setviewGrave={setviewGrave}
                                setviewModerado={setviewModerado}
                                setviewLeve={setviewLeve} 
                                setviewTodos={setviewTodos}
                                
                                setMount={setMount} 
                                disable={disaleButton}
                                setDisabled={setDisableButton}
                                setCurrentPage={setCurrentPage}
                                setLoad={setLoad}
                            />

                            <DenuncesTypeButton 
                                name='Grave' 
                                type='Denunce' 
                                white={viewGrave} 
                                
                                setviewMaximo={setviewMaximo}
                                setviewMuitoGrave={setviewMuitoGrave} 
                                setviewGrave={setviewGrave}
                                setviewModerado={setviewModerado}
                                setviewLeve={setviewLeve} 
                                setviewTodos={setviewTodos} 
                                
                                setMount={setMount} 
                                disable={disaleButton}
                                setDisabled={setDisableButton}
                                setCurrentPage={setCurrentPage}
                                setLoad={setLoad}
                            />
                            
                            <DenuncesTypeButton 
                                name='Moderado'
                                type='Denunce' 
                                white={viewModerado} 
                                
                                setviewMaximo={setviewMaximo}
                                setviewMuitoGrave={setviewMuitoGrave} 
                                setviewGrave={setviewGrave}
                                setviewModerado={setviewModerado}
                                setviewLeve={setviewLeve} 
                                setviewTodos={setviewTodos} 
                                setMount={setMount} 
                                
                                disable={disaleButton}
                                setDisabled={setDisableButton}
                                setCurrentPage={setCurrentPage}
                                setLoad={setLoad}
                            />

                            <DenuncesTypeButton 
                                name='Leve'
                                type='Denunce'  
                                white={viewLeve} 
                                
                                setviewMaximo={setviewMaximo}
                                setviewMuitoGrave={setviewMuitoGrave} 
                                setviewGrave={setviewGrave}
                                setviewModerado={setviewModerado}
                                setviewLeve={setviewLeve} 
                                setviewTodos={setviewTodos}
                                
                                setMount={setMount} 
                                disable={disaleButton}
                                setDisabled={setDisableButton}
                                setCurrentPage={setCurrentPage}
                                setLoad={setLoad}
                            /> 

                            <DenuncesTypeButton 
                                name='Todas'
                                type='Denunce' 
                                white={viewTodos} 
                                
                                setviewMaximo={setviewMaximo}
                                setviewMuitoGrave={setviewMuitoGrave} 
                                setviewGrave={setviewGrave}
                                setviewModerado={setviewModerado}
                                setviewLeve={setviewLeve} 
                                setviewTodos={setviewTodos} 
                                
                                setMount={setMount} 
                                disable={disaleButton}
                                setDisabled={setDisableButton}
                                setCurrentPage={setCurrentPage}
                                setLoad={setLoad}
                            />
                        </div>

                        <div className='filter-styled'>
                            {filter ? 
                                <p className='filter-text-styled'>Todas</p> 
                                :
                                <p className='filter-text-styled-purple'>Todas</p>
                            }
                                <ToggleButton 
                                    setFilter={setFilter} 
                                    filter={filter}
                                    
                                    setMount={setMount} 
                                    disable={disaleButton}
                                    setDisabled={setDisableButton}
                                    setCurrentPage={setCurrentPage}
                                    setLoad={setLoad}
                                />
                            {filter ? 
                                <p className='filter-text-styled-purple'>Pendentes</p> 
                                :
                                <p className='filter-text-styled'>Pendentes</p>
                            }
                        </div>
                        
                        <form onSubmit={searchDiagnosis} >
                            <div className='page-profiles-button'>
                                <button
                                    className='button-search-menu'
                                    type='submit'
                                    id ='pesquisar-button'  
                                    onClick={searchDiagnosis}
                                >
                                    <img 
                                        src={searchButton} 
                                        alt="search" 
                                    />
                                </button>

                                <TextField id="pesquisar-input" 
                                    label="Pesquisar"
                                    size = "small" 
                                    variant="outlined"
                                    className="search-input"
                                    error={error}
                                    value ={search} 
                                    onChange={ (event) => {
                                        setSearch(event.target.value);
                                        setError(false);
                                    }}
                                />

                            </div>
                        </form>

                        <div className = 'container-profile-cards'>
                            {
                                error ?
                                    <p className='progress-circle'>Erro na conexão com o servidor, recarrege a página</p>
                                :
                                    !load ?
                                        <>
                                            {   
                                                denunces.length > 0 ?
                                
                                                    denunces.map((denunce) => (
                                                        <CardDenunciations 
                                                            key = {denunce._id}
                                                            setShowModal = {setShowModalDenunciations}
                                                            data = {denunce}
                                                        />
                                                    ))
                                                
                                                :

                                                    <p className='progress-circle'>Ainda não existem denuncias neste grau de risco.</p>
                                            }
                                        </>
                                    :
                                    
                                        <div className='progress-circle'>
                                            <CircularProgress color='primary' size={25} />
                                        </div>


                            }
                        </div>

                        <div>
                            <Pagination 
                                count={parseInt(pages)}
                                page={currentPage}
                                onChange={(event, value) => {
                                    console.log(value, 'paginationValue');
                                    value === currentPage ? setDisablePagination(false) : setDisablePagination(true)
                                    setCurrentPage(value);
                                    setMount(false);
                                }}
                                color='primary'
                                disabled={disablePagination}
                            />
                        </div>
                        
                    </div>
                    <ModalDenunciations show={showModalDenunciations} setShow={setShowModalDenunciations} changeStatus={handleChangeStatus}/>
                </div>
        : 
            history.push('/')
        }
        </AuthUserContext.Consumer>
    )
}

const condition = authUser => !!authUser;

export default withAuthorization(condition)(ListDenunciations);